import { createAsyncThunk } from "@reduxjs/toolkit";
import { setCleanOpen } from "../cleanSlice";

export const closeCleanThunk = createAsyncThunk(
  "clean/closeClean",
  (args, { dispatch }) => {
    dispatch(setCleanOpen(false));
  },
);
